import React, { useMemo } from 'react';
import useSWR from 'swr';
import { endpoints, poster, fetcherGET, fetcher, fetcherSwr } from '../utils/axios';



export function useGetEcgList(args = {}) {
  const URL = [endpoints.ecg.getEcgList, { params: args }];
  const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(() => ({
    ecgReport: data?.data || null,
     pagination: data?.pagination || {
        total: 0,
        page: args.page || 1,
        limit: args.limit || 10,
        totalPages: 0,
      },
      data: data || [],
    isLoading,
    error,
    isValidating,
  }), [data, error, isLoading, isValidating, args.page, args.limit]);

  return memoizedValue;
}


export function useGetEcgGraph(args ={}, path = ''){
  const URL = [`${endpoints.ecg.getEcgGraph}${path}`, { params: args }];
  const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);
  const memoizedValue = useMemo(() => ({
    ecgGraph: data?.data || null,
    isLoading,
    error,
    isValidating,
  }), [data, error, isLoading, isValidating]);
  return memoizedValue;
}

// Direct GET helper for ad-hoc queries (OTP send/verify and fetching other reports)
export const getEcgReportAction = async (args = {}) => {
  try {
    const response = await fetcherGET(`${endpoints.ecg.getEcgList}`, { params: args });
    return response;
  } catch (error) {
    console.error('getEcgReportAction error:', error);
    return error?.response?.data || { success: false, message: error?.message };
  }
};

export function useGetEcgDetails(args = {}, path = '') {
  const URL = [`${endpoints.ecg.getEcgDetails}${path}`, { params: args }];

  const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(() => ({
    EcgReport: data?.data || null,
    isLoading,
    error,
    isValidating,
  }), [data, error, isLoading, isValidating]);

  return memoizedValue;
}



export const requestInterpretation = async (args) => {
  try {
    const response = await poster(`${endpoints.ecg.requestInterpretation}`, args);
    return response;
  } catch (error) {
    console.error('requestInterpretation error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};


//for directly fetching the ecg list without swr 

export const reportsData = async (args = {}) => {
  try {
    const response = await fetcherGET(endpoints.ecg.exportReports, {
      params: args,
    });

    return {
      ecgReport: response?.data || [],
      pagination: response?.data?.pagination || {
        total: 0,
        page: args.page || 1,
        limit: args.limit || 10,
        totalPages: 0,
      },
    };
  } catch (error) {
    console.error("getEcgList error:", error);

    return {
      ecgReport: [],
      pagination: {
        total: 0,
        page: args.page || 1,
        limit: args.limit || 10,
        totalPages: 0,
      },
      error,
    };
  }
};